import React from 'react';

import { get } from '@lumapps/constants';
import { LoginPage } from '@lumapps/login/components/LoginPage';
import { SendEmailForm } from '@lumapps/login/components/SendEmailForm';
import type { StepProps } from '@lumapps/lumx-layouts/types';
import { useTranslate } from '@lumapps/translations';

import { SendEmailForm as sendEmailFormApi } from '../../api';
import { SEND_MAGIC_LINK_FORM_ID, TITLE_ID } from '../../constants';
import { MAGIC_LINK } from '../../keys';

const { customerId } = get();
const nextUrl = window.location.origin;

/**  SendEmailFormStep: Component which render the step of send email.
 */
export const SendEmailFormStep: React.FC<StepProps> = ({ backButton, goToNextStep, ...props }) => {
    const { translateKey } = useTranslate();
    const [hasApiError, setHasApiError] = React.useState(false);

    const onSubmit = React.useCallback(
        (email: string) => {
            setHasApiError(false);
            sendEmailFormApi(customerId, email, nextUrl)
                .then(() => goToNextStep())
                .catch(() => setHasApiError(true));
        },
        [goToNextStep],
    );

    return (
        <LoginPage before={backButton} title={translateKey(MAGIC_LINK.SIGN_IN_WITH_EMAIL)} displayPoweredBy>
            <SendEmailForm
                formId={SEND_MAGIC_LINK_FORM_ID}
                titleId={TITLE_ID}
                isMagicLink
                {...props}
                goToNextStep={goToNextStep}
                buttonText={translateKey(MAGIC_LINK.SEND_MAGIC_LINK)}
                onSubmit={onSubmit}
                hasSubmitError={hasApiError}
            />
        </LoginPage>
    );
};
